var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInterior(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2207",
    transform: "translate(-4221 -3092)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 34",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(4221 3092)",
    style: {
      fill: "rgba(255,115,29,.1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.433 36.273a1.293 1.293 0 0 1-1.261-1.261v-1.767h-.547a4.463 4.463 0 0 1-3.28-1.345A4.463 4.463 0 0 1 2 28.62V18.361A4.05 4.05 0 0 1 3.3 15.1a4.574 4.574 0 0 1 3.069-1.114v-3.613A4.179 4.179 0 0 1 10.745 6H30.3a4.2 4.2 0 0 1 3.132 1.219 4.308 4.308 0 0 1 1.2 3.153v3.616A4.574 4.574 0 0 1 37.7 15.1a4.05 4.05 0 0 1 1.3 3.261V28.62a4.594 4.594 0 0 1-4.625 4.625h-.547v1.766a1.261 1.261 0 0 1-2.523 0v-1.766H9.694v1.766a1.293 1.293 0 0 1-1.261 1.261zm-1.808-5.55h27.75a2.155 2.155 0 0 0 2.1-2.1V18.361a1.851 1.851 0 1 0-3.7 0v7.4H8.223v-7.4a1.736 1.736 0 0 0-1.85-1.85 1.736 1.736 0 0 0-1.85 1.85V28.62a2.017 2.017 0 0 0 .631 1.472 2.017 2.017 0 0 0 1.472.631zm4.12-7.484h19.51v-4.878a3.754 3.754 0 0 1 .589-2.165A5.705 5.705 0 0 1 32.1 14.83v-4.457a1.736 1.736 0 0 0-1.85-1.85H10.745a1.736 1.736 0 0 0-1.85 1.85v4.457a5.705 5.705 0 0 1 1.262 1.37 3.754 3.754 0 0 1 .589 2.165zm9.755 0zm0 7.484zm0-4.962z",
    transform: "translate(4232 3102)",
    style: {
      fill: "#ff731d"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInterior);
export default __webpack_public_path__ + "static/media/icon-interior.649a447e.svg";
export { ForwardRef as ReactComponent };